import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useAuth } from "../contexts/AuthContext";
import customerService from "../services/customerService";
import AddressModal from "../components/AddressModal";
import { toast } from "react-toastify";
import { Modal, Button, Badge } from "react-bootstrap";

const AddressesPage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  
  // Adres bilgileri state'leri
  const [addresses, setAddresses] = useState({
    shipping: [],
    billing: [],
  });
  
  // Modal state'leri
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("shipping"); // 'shipping' veya 'billing'
  const [selectedAddress, setSelectedAddress] = useState(null);
  
  // Silme modal state'leri
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);

  useEffect(() => {
    fetchAddresses();
  }, []);
  
  const fetchAddresses = async () => {
    try {
      setLoading(true);
      // API'den adres bilgilerini çek
      const response = await customerService.getCustomerAddresses();
      
      if (response.succeeded) {
        // Adresleri tip göre grupla
        const shipping =
          response.addresses?.filter((a) => a.addressType === 1) || [];
        const billing =
          response.addresses?.filter((a) => a.addressType === 2) || [];
        
        setAddresses({
          shipping,
          billing,
        });
      } else {
        setError(response.message || "Adresler yüklenirken bir hata oluştu");
      }
      
      setLoading(false);
    } catch (error) {
      console.error("Adres bilgileri alınırken hata oluştu:", error);
      setError(
        "Adres bilgileri alınırken hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
      setLoading(false);
    }
  };

  const handleAddAddress = (type) => {
    setModalType(type);
    setSelectedAddress(null);
    setShowModal(true);
  };
  
  const handleEditAddress = (address, type) => {
    setModalType(type);
    setSelectedAddress(address);
    setShowModal(true);
  };
  
  const handleDeleteAddress = async (addressId) => {
    try {
      setLoading(true);
      const response = await customerService.deleteCustomerAddress(addressId);
      
      if (response.succeeded) {
        toast.success("Adres başarıyla silindi");
        // Adresleri tekrar yükle
        fetchAddresses();
        // Modal'ı kapat
        setShowDeleteModal(false);
      } else {
        setError(response.message || "Adres silinirken bir hata oluştu");
        setLoading(false);
        // Modal'ı kapat
        setShowDeleteModal(false);
      }
    } catch (error) {
      console.error("Adres silinirken hata oluştu:", error);
      setError(
        "Adres silinirken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
      setLoading(false);
      // Modal'ı kapat
      setShowDeleteModal(false);
    }
  };
  
  const handleSetDefaultAddress = async (addressId, type) => {
    try {
      setLoading(true);
      const response = await customerService.setDefaultAddress(
        addressId,
        type === "shipping" ? 1 : 2
      );
      
      if (response.succeeded) {
        toast.success(
          `Varsayılan ${
            type === "shipping" ? "teslimat" : "fatura"
          } adresi güncellendi`
        );
        // Adresleri tekrar yükle
        fetchAddresses();
      } else {
        setError(response.message || "Adres güncellenirken bir hata oluştu");
        setLoading(false);
      }
    } catch (error) {
      console.error("Adres güncellenirken hata oluştu:", error);
      setError(
        "Adres güncellenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
      setLoading(false);
    }
  };
  
  const handleSaveAddress = async (addressData) => {
    try {
      // Yeni adres eklendiyse veya adres güncellendiyse
      toast.success(
        `Adres başarıyla ${selectedAddress ? "güncellendi" : "eklendi"}`
      );
      // Adresleri tekrar yükle
      fetchAddresses();
    } catch (error) {
      console.error("Adres kaydedilirken hata oluştu:", error);
      setError(
        "Adres kaydedilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
    }
  };

  // Silme işlemi için modal açma fonksiyonu
  const openDeleteModal = (addressId) => {
    setAddressToDelete(addressId);
    setShowDeleteModal(true);
  };

  const renderAddresses = (addresses, type) => {
    if (addresses.length === 0) {
      return (
        <div className="alert border-0 text-dark" style={{ backgroundColor: "#f7f7f7" }}>
          Henüz {type === "shipping" ? "teslimat" : "fatura"} adresiniz
          bulunmuyor.
        </div>
      );
    }
    
    return (
      <div className="row g-4 py-16">
        {addresses.map((address, index) => (
          <div key={address.id || index} className="col-lg-6 mb-4">
            <div className={`p-24 position-relative h-100 rounded-8 bg-white box-shadow-sm ${address.isDefault ? 'border border-2 border-success' : 'border border-gray-200'}`}>
              {address.isDefault && (
                <Badge bg="success" pill className="position-absolute top-0 end-0 m-2 small">Varsayılan</Badge>
              )}
              <div className="d-flex flex-column h-100">
                <h5 className="fw-bold mb-3" style={{ color: "#333", fontSize: "18px" }}>{address.firstName} {address.lastName}</h5>
                <p className="mb-2" style={{ color: "#666", fontSize: "14px" }}>{address.address}</p>
                <p className="mb-2" style={{ color: "#666", fontSize: "14px" }}>{address.district} / {address.province}</p>
                <p className="mb-3" style={{ color: "#666", fontSize: "14px" }}>{address.phone}</p>
                
                <div className="d-flex mt-auto pt-3 gap-2">
                  {!address.isDefault && (
                    <button className="btn btn-outline-main btn-sm" onClick={() => handleSetDefaultAddress(address.id, type)}>Varsayılan Yap</button>
                  )}
                  <button className="btn btn-main btn-sm" onClick={() => handleEditAddress(address, type)}>Düzenle</button>
                  <button className="btn btn-danger btn-sm" onClick={() => openDeleteModal(address.id)}>Sil</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <ColorInit color={false} />
      <ScrollToTop smooth color="#299E60" />
      <Preloader />
      <HeaderOne />
      <Breadcrumb title={"Adres Bilgilerim"} />

      <div className="py-80">
        <div className="container container-lg">
          <div className="row">
            <div className="col-12">
                {loading && (
                <div className="text-center my-5">
                  <div
                    className="spinner-border"
                    style={{ color: "#37B24D" }}
                    role="status"
                  >
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                )}
                
              {error && (
                <div className="alert border-0">{error}</div>
              )}
              {successMessage && (
                <div className="alert border-0">
                  {successMessage}
                </div>
              )}
                
                {!loading && (
                  <>
                  <div className="mb-48 pb-48">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                      <h3 className="section-heading m-0">Teslimat Adresleri</h3>
                      <button className="btn btn-main btn-sm" onClick={() => handleAddAddress("shipping")}>Yeni Teslimat Adresi</button>
                    </div>
                    {renderAddresses(addresses.shipping, "shipping")}
                    </div>
                    
                  <div className="mt-48 pt-48">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                      <h3 className="section-heading m-0">Fatura Adresleri</h3>
                      <button className="btn btn-main btn-sm" onClick={() => handleAddAddress("billing")}>Yeni Fatura Adresi</button>
                    </div>
                    {renderAddresses(addresses.billing, "billing")}
                    </div>
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
      
      {/* Adres Ekleme/Düzenleme Modalı */}
      <AddressModal 
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={handleSaveAddress}
        existingAddress={selectedAddress}
        addressType={modalType}
      />
      
      {/* Adres Silme Onay Modalı */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Adres Silme</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Bu adresi silmek istediğinizden emin misiniz?</p>
          <p className="text-muted small">Bu işlem geri alınamaz.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => setShowDeleteModal(false)}
          >
            İptal
          </Button>
          <Button 
            variant="danger" 
            onClick={() => handleDeleteAddress(addressToDelete)}
          >
            Evet, Sil
          </Button>
        </Modal.Footer>
      </Modal>

      <ShippingOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default AddressesPage; 
